import { AppNS } from 'app';
import { ApiCollectionResponse, Params } from 'app/types';

import { getCollectionResponse, request } from '../config';

const INVITATIONS_URL = 'invitations';

export function apiGetAgencyStaff(
  companyId: string,
  data: Params,
  signal?: AbortSignal
): Promise<ApiCollectionResponse<AppNS.Invitation>> {
  return request(
    {
      url: `${INVITATIONS_URL}.json`,
      method: 'GET',
      params: { ...data, companyId },
      signal,
    },
    (data) => getCollectionResponse<AppNS.Invitation>(data)
  );
}

export function apiCreateInvitation(data: Partial<AppNS.Invitation>, signal?: AbortSignal): Promise<AppNS.Invitation> {
  return request(
    {
      url: `${INVITATIONS_URL}.json`,
      method: 'POST',
      data: {
        invitation: data,
      },
      signal,
    },
    (data) => data.model
  );
}

export function apiUpdateInvitation(
  id: string,
  data: Partial<AppNS.Invitation>,
  signal?: AbortSignal
): Promise<AppNS.Invitation> {
  return request(
    {
      url: `${INVITATIONS_URL}/${id}.json`,
      method: 'PATCH',
      data: {
        invitation: data,
      },
      signal,
    },
    (data) => data.model
  );
}

export function apiUpdateInvitationState(
  id: string,
  data: AppNS.InvitationState,
  cancellationReason?: string,
  signal?: AbortSignal
): Promise<AppNS.Invitation> {
  return request(
    {
      url: `${INVITATIONS_URL}/${id}/change-state.json`,
      method: 'PATCH',
      data: {
        invitation: {
          state: data,
          cancellationReason,
        },
      },
      signal,
    },
    (data) => data.model,
    {
      errorType: 'legacy',
      removeResponseInterceptor: false,
      removeRequestInterceptor: false,
    }
  );
}

export function apiDeleteInvitation(id: string, signal?: AbortSignal): Promise<AppNS.Invitation> {
  return request(
    {
      url: `${INVITATIONS_URL}/${id}.json`,
      method: 'DELETE',
      signal,
    },
    (data) => data.model
  );
}

export function apiGetInvitationById(id: string, signal?: AbortSignal): Promise<AppNS.Invitation> {
  return request(
    {
      url: `${INVITATIONS_URL}/${id}.json`,
      method: 'GET',
      signal,
    },
    (data) => data.model
  );
}

export function apiGetUserInvitations(
  data: Params,
  signal?: AbortSignal
): Promise<ApiCollectionResponse<AppNS.Invitation>> {
  return request(
    {
      url: `${INVITATIONS_URL}.json`,
      method: 'GET',
      params: { ...data },
      signal,
    },
    (data) => getCollectionResponse<AppNS.Invitation>(data)
  );
}
